import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
    sectionName: Yup.object({
                    label: Yup.string()
                        .required()
                        .min(1, 'Too Short!')
                        .max(250, 'Too Long!')
                        .matches(/^[ A-Za-z0-9_-]*$/, 'Special chars are not allowed')
                        .nullable(false),
                    value: Yup.string()
                        .required('Required')
                        .min(1, 'Too Short!')
                        .max(250, 'Too Long!')
                        .matches(/^[ A-Za-z0-9_-]*$/, 'Special chars are not allowed')
                        .nullable(false),
                }),
    roomName: Yup.string()
        .min(1, 'Too Short!')
        .max(256, 'Too Long!')
        .matches(/^[ A-Za-z0-9_-]*$/, 'Special chars are not allowed')
        .required('Required'),
    bedName: Yup.string()
        .min(0)
        .max(256, 'Too Long!')
        .matches(/^[ A-Za-z0-9_-]*$/, 'Special chars are not allowed')
});